import PropTypes from 'prop-types'
import classNames from 'classnames'

import DatePicker from 'react-datepicker'
import { ReactComponent as IconChevron } from 'assets/icons/IconChevron.svg'
import { useState } from 'react'

const Datepicker = ({
  onChange,
  startDate,
  endDate,
  placeholder,
  dateFormat,
  selectsRange,
  isOpenButton,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const onClickOpenButton = (e) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }

  return (
    <div className="datepicker">
      <DatePicker
        {...rest}
        placeholderText={placeholder}
        dateFormat={dateFormat}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange={selectsRange}
        showMonthDropdown
        open={isOpen}
        onCalendarOpen={() => setIsOpen(true)}
        onCalendarClose={() => setIsOpen(false)}
      />
      {isOpenButton && (
        <button
          className={classNames('datepicker__open-button', {
            '-open': isOpen,
          })}
          onClick={onClickOpenButton}
        >
          <IconChevron />
        </button>
      )}
    </div>
  )
}

Datepicker.defaultProps = {
  isOpenButton: true,
  open: false,
  dateFormat: 'MMM d, h:mm a',
  placeholder: '',
}

Datepicker.propTypes = {
  onChange: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.string,
  dateFormat: PropTypes.string,
  selectsRange: PropTypes.bool,
  isOpenButton: PropTypes.bool,
}

export default Datepicker
